__turbopack_context__.v({
  "container": "NavItemCard-module-scss-module__h5JV-W__container",
});
